import _ from 'lodash'

export default class Validation
  constructor: (@spec) ->

  validate: (value) ->
    _.compact(@spec.map (condition) => @validateCondition(condition, value))

  validateCondition: (condition, value) ->
    switch condition.type
      when 'min_length'
        unless value.length >= condition.value
          condition.message.replace('{value}', condition.value)
      when 'match'
        unless value.match(RegExp(condition.value))
          condition.message
